export default "__VITE_ASSET__6061b5b1__"